import { render, staticRenderFns } from "./NotificacoesUsuario.vue?vue&type=template&id=9e24cf6a"
import script from "./NotificacoesUsuario.vue?vue&type=script&lang=js"
export * from "./NotificacoesUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports